import classNames from 'classnames';
import { colors, screen } from 'components/styles/variables';
import OncomingAutomobile from 'public/static/images/onboarding/oncoming-automobile.svg';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import OnboardingCta from './Buttons/HelpMeSearchCta';

interface OnboardingBannerProps {
  className?: string;
  onClick?: () => void;
}

export default function OnboardingBanner({
  className,
  onClick,
}: OnboardingBannerProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <>
      <div className={classNames('onboarding-banner', className)}>
        <div className="automobile-icon">
          <Image src={OncomingAutomobile} alt="automobile-icon" width={26} height={26} />
        </div>
        <p className="text">{t('onboarding.banner.header')}</p>
        <div className="onboarding-cta">
          <OnboardingCta className="onboarding-cta" onClick={onClick} />
        </div>
      </div>
      <style jsx>{`
        .onboarding-banner {
          display: flex;
          align-items: center;
          height: 72px;
          width: 100%;
          max-width: 1038px;
          border-width: 1px;
          border-style: solid;
          border-color: ${colors.G2};
          border-radius: 16px;
          margin-bottom: 24px;
          padding-left: 16px;
          padding-right: 24px;
        }

        .text {
          font-weight: 700;
          font-size: 18px;
          text-wrap: nowrap;
          width: 100%;
        }
        .onboarding-cta {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: end;
        }

        .automobile-icon {
          padding-right: 12px;
        }

        @media screen and (max-width: ${screen.smMin}) {
          .automobile-icon {
            display: none;
          }
          .onboarding-banner {
            border-radius: 0;
            padding-right: 16px;
            border-left: none;
            border-right: none;
            margin-bottom: 0;
          }

          .text {
            text-wrap: wrap;
            font-size: 16px;
          }
        }
      `}</style>
    </>
  );
}
